import { getAccountsQueryOptions } from '@features/accounts/api';
import { filterAccountsByType } from '@features/accounts/filterAccountsByType';
import { Account } from '@features/accounts/types';
import { getProfileQueryOptions } from '@features/user/api';
import { GetProfileResponse } from '@features/user/types/get-profile-response';
import { createFileRoute, notFound } from '@tanstack/react-router';
import HighYieldSavingsSettingsLayout
  from 'src/routes/_authenticated/dashboard/high-yield-savings/$accountId/-high-yield-savings-settings-layout';

export const Route = createFileRoute(
  '/_authenticated/dashboard/high-yield-savings/$accountId/settings',
)({
  loader: async ({
    context,
    params,
  }): Promise<{ account: Account; profile: GetProfileResponse }> => {
    const profile = await context.queryClient.ensureQueryData({
      queryKey: getProfileQueryOptions.queryKey,
      queryFn: getProfileQueryOptions.queryFn,
    });

    const accounts = await context.queryClient.ensureQueryData({
      queryKey: getAccountsQueryOptions.queryKey,
      queryFn: getAccountsQueryOptions.queryFn,
    });

    const { savingsAccounts } = filterAccountsByType(accounts?.visible);

    const account = savingsAccounts.find(
      (acc) => acc.uuid === params.accountId,
    );

    if (!account) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw notFound();
    }

    return { account, profile };
  },
  component: HighYieldSavingsSettingsLayout,
});
